<div class="flex-1 overflow-y-auto overflow-x-hidden">
  <app-brochure-analysis-modal />
  <app-export-modal [(visible)]="showExportModal" />
  <app-transfer-trip-dialog />

  <!-- Bulk Upload Modal -->
  <p-dialog
    [visible]="brochureAnalysisService.showBulkUploadModal()"
    (visibleChange)="brochureAnalysisService.showBulkUploadModal.set($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [style]="{ width: '90%', maxWidth: '900px' }"
    (onHide)="onBulkModalClose()"
  >
    <ng-template pTemplate="header">
      <h2 class="text-xl font-bold">
        {{ "calculator.bulkAnalysis" | transloco }}
      </h2>
    </ng-template>

    <app-bulk-brochure-analysis (closed)="onBulkModalClose()" />
  </p-dialog>

  @if (showPage) {
    @if (travelBoardService.loading()) {
      <!-- Loading spinner -->
      <div class="flex h-[calc(100dvh-200px)] items-center justify-center">
        <app-greentripper-loader size="xl"></app-greentripper-loader>
      </div>
    } @else if (travelBoardService.data().length > 0) {
      <app-page-header
        [title]="'travelBoards.travelOffers' | transloco"
        [actions]="headerActions"
      >
        <app-export-company-report-to-pdf />
        <app-export-trips-to-xls />
      </app-page-header>
      <app-trip-creation-modal />

      <!-- SECTION: Vue d'ensemble -->
      <app-collapsible-section
        [title]="'travelBoard.overview' | transloco"
        icon="bar-chart-2"
        storageKey="overviewCollapsed"
      >
        <app-board-overview-section />
      </app-collapsible-section>

      <!-- SECTION: Graphique -->
      <app-collapsible-section
        [title]="'travelBoard.chart.title' | transloco"
        icon="bar-chart-3"
        storageKey="chartCollapsed"
      >
        <app-emission-per-trip-chart />
      </app-collapsible-section>

      <!-- SECTION: Liste des voyages -->
      <app-collapsible-section
        [title]="'travelBoard.tripList' | transloco"
        icon="list"
        storageKey="tripListCollapsed"
        marginWhenOpen=""
        marginWhenCollapsed=""
      >
        <app-board-trip-list-section
          (searchChange)="onSearchChange($event)"
          (filterChange)="onFilterChange($event)"
          (paginationChange)="onPaginationChange($event)"
        />
      </app-collapsible-section>
    } @else {
      <app-empty-view />
    }
  }

  <!-- Confirmation Dialog -->
  <p-confirmDialog rejectButtonStyleClass="p-button-outlined">
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3">
        <div
          class="flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-primary-500"
        >
          <i class="pi pi-trash text-2xl"></i>
        </div>
        <span class="text-xl font-semibold text-greyscale-900">{{
          "travelBoards.deleteConfirmation" | transloco
        }}</span>
      </div>
    </ng-template>
  </p-confirmDialog>
</div>
